import {
  admin,
  anetarShm,
  konkurrent,
  pedagog,
  pjesmarres,
  specialistFF,
  specialistFv,
  student,
  pergjegjesDepartamentiFv,
  kancelar,
} from '../components/common/common-functions/common-functions';
import {
  allAnetarKomisioni,
  allFormimiFillestar,
} from '../constants/all-anetar-komisioni';

interface RoutesProps {
  [key: string]: string[];
}

const allRoles = [
  ...allFormimiFillestar,
  ...allAnetarKomisioni,
  specialistFv,
  student,
  pjesmarres,
  konkurrent,
  pergjegjesDepartamentiFv,
  kancelar,
];

const routesWithPermissions: RoutesProps = {
  '/login': [],
  '/forgot-password': [],
  '/signup': [],
  '/redirect': [],
  '/pjesemarresit': [admin, kancelar],
  '/dashboard': [admin, kancelar],
  '/administrim-konkurrim': [admin, anetarShm, kancelar],
  '/administrim-formimiFillestar': [admin, specialistFF, kancelar],
  '/administrim-formimiVazhdues': [
    admin,
    specialistFv,
    pergjegjesDepartamentiFv,
    kancelar,
  ],
  '/konkurrime': [konkurrent, ...allAnetarKomisioni, admin, kancelar],
  '/konkurrime/aplikim': [konkurrent, ...allAnetarKomisioni, admin, kancelar],
  '/program-tematik': [pjesmarres],
  '/propozo-trajnim': [pjesmarres],
  '/kalendari': [pjesmarres],
  '/roli-trajnues': [pjesmarres],
  '/listeprezenca-per-pjesemarres': [pjesmarres],
  '/rezultateFaza': [konkurrent],
  '/trajnime-kalendari': [
    specialistFv,
    admin,
    pergjegjesDepartamentiFv,
    kancelar,
  ],
  '/trajnime-kalendari/:id': [
    specialistFv,
    pjesmarres,
    admin,
    pergjegjesDepartamentiFv,
    kancelar,
  ],
  '/propozime': [specialistFv],
  '/trajnime-program-tematik': [
    specialistFv,
    admin,
    pergjegjesDepartamentiFv,
    kancelar,
  ],
  '/rankime': [anetarShm, admin, kancelar],
  '/orari': [admin, pedagog, specialistFF, student, kancelar],
  '/ndryshoFjalekalimin': allRoles,
  '/two-fa': allRoles,
  '/faza-aktive': [admin, anetarShm, kancelar],
  '/modulet': [],
  '/lende-akademike': [...allFormimiFillestar, student],
  '/lende-mesimore': [...allFormimiFillestar, student],
  '/evidenca': [pedagog, specialistFF, kancelar, admin],
  '/list-prezenca': [...allFormimiFillestar, student],
  '/vleresime': [pedagog, specialistFF],
  '/vleresime-lende-mesimore': [pedagog, specialistFF, kancelar],
  '/vleresime-gjyqe-imituese': [pedagog, admin, kancelar],
  '/liste-prezenca/:id': [
    specialistFv,
    admin,
    pergjegjesDepartamentiFv,
    kancelar,
  ],
  '/gjyqe-imituese': [...allFormimiFillestar, student],
  '/klinike-ligjore': [...allFormimiFillestar, student],
  '/liste-prezenca-trajnimet': [
    specialistFv,
    admin,
    pergjegjesDepartamentiFv,
    kancelar,
  ],
  '/audit': [admin, kancelar],
  '/vleresime-student': [student],
  '/raporte': [
    pedagog,
    specialistFF,
    specialistFv,
    pergjegjesDepartamentiFv,
    kancelar,
  ],
  '/vleresime-klinike-ligjore': [...allFormimiFillestar],
  '/auth/callback': [],
  '/logout-success': allRoles,
};

export default routesWithPermissions;
